import { render, staticRenderFns } from "./WaveletMarketplace.vue?vue&type=template&id=cbe8a8ec&scoped=true&"
import script from "./WaveletMarketplace.vue?vue&type=script&lang=js&"
export * from "./WaveletMarketplace.vue?vue&type=script&lang=js&"
import style0 from "./WaveletMarketplace.vue?vue&type=style&index=0&id=cbe8a8ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe8a8ec",
  null
  
)

export default component.exports